module.exports = __webpack_public_path__ + "static/meta/sqs/2025/layout_metadata.285dab7.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2025/meta/layout_metadata.tsv
// module id = tyg4
// module chunks = 0